import React from 'react';

import { useTranslation } from 'react-i18next';

export const PasswordResetFooter: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="font-base mb-[16vh] pt-9 text-center text-sm text-black/65">
      <p>{t('passwordReset.still')}</p>
      <div className="flex justify-center gap-1">
        {t('passwordReset.emailUs')}
        <span className="text-primary-500">{t('passwordReset.emailLink')}</span>
      </div>
    </div>
  );
};
